import React from 'react'

const PaymentResult = () => {
    return (
        <div>PaymentResult</div>
    )
}

export default PaymentResult